var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-section"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_vm.title ? _c('div', {
    staticClass: "tit-wrap justify-center text-center"
  }, [_c('h2', {
    staticClass: "main-tit"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._t("default")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }